export default "__VITE_ASSET__CH99p6XH__"